<section class="machines-panel">
  <h4>OEM machines</h4>
  <p class="muted small">
    Link a {{ providerLabel }} machine to one of your Harvest Mate harvesters.
  </p>

  @if (disabled) {
  <div class="disabled-hint">
    Grant data access to at least one organisation above before linking
    {{ providerLabel }} machines.
  </div>
  } @if (!disabled && needsGrantHint) {
  <div class="disabled-hint">Grant at least one org's data access first.</div>
  } @if (!disabled && loading) {
  <div class="muted">Loading machines&hellip;</div>
  } @if (!disabled && errorMessage) {
  <div class="error">{{ errorMessage }}</div>
  } @if (!disabled && !loading && !errorMessage && machines.length === 0 &&
  !needsGrantHint) {
  <div class="muted">No machines available from {{ providerLabel }}.</div>
  } @if (!disabled && !loading && !errorMessage && !needsGrantHint && machines.length > 0) {
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Machine</th>
        <th scope="col">Linked harvester</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      @for (m of machines; track m) {
      <tr>
        @if (rowFor(m); as state) {
        <td>{{ m.oem_machine_name }}</td>
        <td>
          @if (isLinked(m)) {
          {{ harvesterLabel(m.linked_harvester_id) }}
          } @else if (isLinkedElsewhere(m)) {
          <!-- SRA003-524: claimed by another operator in the org. Privacy-aware
               — no identity, just unavailable. -->
          <span class="muted small">Linked by another operator</span>
          } @else {
          <select
            [(ngModel)]="state.selectedHarvesterId"
            [disabled]="state.busy"
          >
            <option [ngValue]="undefined">Select a harvester&hellip;</option>
            @for (h of harvesters; track h) {
            <option [ngValue]="h.id">
              {{ h.model_name }}
            </option>
            }
          </select>
          }
        </td>
        <td>
          @if (isLinked(m)) {
          <button
            class="btn-small"
            type="button"
            (click)="unlink(m)"
            [disabled]="state.busy"
          >
            Remove linkage
          </button>
          } @else if (isLinkedElsewhere(m)) {
          <span class="muted small">Unavailable</span>
          } @else {
          <button
            class="btn-oem-primary"
            type="button"
            (click)="link(m)"
            [disabled]="state.busy"
          >
            Link
          </button>
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
  }
</section>
